// extracted by mini-css-extract-plugin
export default {"UtilityModelDocumet":"UtilityModelDocumet_UtilityModelDocumet__JrF39","laws__link":"UtilityModelDocumet_laws__link__uAuwW"};